<style >
	.title {
		line-height: 40px;
		height: 40px;
		text-align: center;
		background-color: #3399ff;
		color: white;
	}
	
	.chating-action-box {
		background-color: white;
		height: 218px;
		width: 100%;
		display: flex;
		flex-direction: column;
	}
	.mtextarea {
	}
	
	.el-textarea__inner {
		box-shadow: 0 0 0 !important;
		background-color: white !important;
		color: black !important;
		border: 0;
		font-size: 16px;
		color: #333333;
	}
	
	.chating-menu {
		width: 100%;
		height: 40px;
		border-top: solid 1px #dcdcdc;
		display: flex;
		flex-direction: row;
		align-items: center;
		color: #999999;
	}
	
	.im-content-box {
		overflow-y:scroll;
		background: #F6F6F6;
	}
	.im-content-box2 {
		padding: 8px;
	}
	.im-avatar {
		width:40px; height:40px;
	}
	.im-status {
		background:#DDDDDD; margin: 6px 0; font-size: 10px; padding: 3px 8px; color: white;
		border-radius: 3px;
	}
	.im-text {
		background-color: white; padding: 10px; border-radius: 5px; 
		max-width: 300px;
		overflow:hidden;
		word-wrap:break-word;
	}
	.im-text img {
		max-width: 200px;
	}
	.im-time {
		color:#999; font-size:12px;
	}
	.flrs {
		display: flex;
		flex-direction: row;
	}
	.flc {
		display: flex;
		flex-direction: column;
	}
	.mdot {
		width: 20px;
		height: 20px;
		background:red;
		color:white;
		font-size:12px;
		text-align:center;
		line-height: 20px;
		border-radius: 20px;
		position: absolute;
		top:18px;
		right: 10px;
	}
	
	.el-dialog__body {
		padding: 5px 10px !important;
	}
</style>
<template>
	<div>
		<div style="display: flex; flex-direction: row; height: 500px;">
			<div style="width: 300px; background-color: white; border-right: solid 1px white;">
				<div class="title">用户列表</div>
				<div style="display: flex; flex-direction: row; height: 40px; align-items: center;">
					<el-input placeholder="搜索" clearable v-model="filterText" size="small" style="margin-top: 5px;"></el-input>
				</div>
				<div style="overflow-y: scroll; height: 400px; padding: 20px;">
					<el-tree :props="props"
						ref="treeRef"
						:data="listData"
						show-checkbox
						@check-change="handleCheckChange"
						:filter-node-method="filterNode"
					>
						
					</el-tree>
				</div>
			</div>
			<div style="flex-grow: 1; ">
				<div class="chating-action-box">
					<div style='background-color: #F6F6F6; padding: 10px;'>
						<el-input ref="myInput" class="mtextarea" v-model="be_message" type="textarea" rows='17' resize="none"></el-input>
					</div>
					<div style="background-color: #F6F6F6; display: flex; flex-direction: row; justify-content: right; padding: 5px 0 16px 0;">
						
							<el-upload :show-file-list="false" action="https://ws.fkinfo88.com/Api/Publics/uploadImage" :on-success="UploadSuccess" :before-upload="beforeAvatarUpload"  accept="image/*">
								<el-button type="warning" style="width: 120px; margin-right: 10px;">
									发送图片
									</el-button>
							</el-upload>
						
						<el-button type="primary" style="width: 120px; margin-right: 10px;" @click="sendMessageFunc">发送</el-button>
					</div>
				</div>
			</div>
		</div>
		
	</div>
</template>

<script>
	export default {
		props:['appInfo'],
	    data() {
			return {
				filterText:'',
				props:{
					label:'nickname',
					children:'child'
				},
				listData:[],
				checkList:[],
				count:1,
				be_message:''
			}
	    },
		watch: {
			filterText(val) {
				console.log(val);
				this.$refs.treeRef.filter(val)
			}
		},
		created() {
			console.log('created');
			this.getUserList();
			this.checkList = [];
		},
	    methods: {
			filterNode(value, data) {
				if (!value) return true
				console.log(data);
				return data.nickname.includes(value)
			},
			searchFunc(){
				console.log(this.search);
			},
			getUserList(){
				let _this = this;
				const loading = this.$loading({lock: true, text: '获取会员列表中', background: 'rgba(0, 0, 0, 0.7)'});
				_this.$api.post(this.appInfo.api_url, {}).then(res=>{
					loading.close();
					if(res.code == 200)
					{
						_this.listData = res.data.list;
					}else{
						return _this.$message({
							 message: res.msg,
							 type: 'warning',
						});
					}
				}).catch(err=>{
					loading.close();
				});
			},
			handleCheckChange(data, checked, indeterminate){
				if(data.imid){
					if(checked){
						this.checkList.push(data.imid);
					}else{
						this.checkList = this.checkList.filter((element) => element !== data.imid);
					}
				}
			},
			beforeAvatarUpload(file){
				if(this.checkList.length == 0){
					return this.$message({ message: '请选择要发送的用户', type: 'warning' });
				}
				return;
				let _this = this;
				let reader = new FileReader();
				let ret =  reader.readAsDataURL(file);
				reader.onload = () => {
					this.$emit('message', {message:reader.result, type:'image', list:this.checkList});
				};
				return false;
			},
			sendImageMessageFunc(){
				
			},
			sendMessageFunc(){
				console.log('111');
				if(this.checkList.length == 0){
					return this.$message({ message: '请选择要发送的用户', type: 'warning' });
				}
				if(this.be_message.trim().length == 0){
					return this.$message({ message: '请输入要群发的内容', type: 'warning' });
				}
				this.checkList;
				this.be_message.trim();
				this.$emit('message', {message:this.be_message.trim(), type:'text', list:this.checkList});
			},
			beforeUpload(file){
			},
			UploadSuccess(res, file, fileList){
				if(res.code == 200)
				{
					this.$emit('message', {message:res.data.url, type:'image', list:this.checkList});
				}else{
					return this.$message({ message: res.msg, type: 'warning' });
				}
			},
			UploadError(){
				return this.$message({ message: '上传失败，请重试', type: 'warning' });
			}
	    }
	  }
</script>

